import { Injectable } from '@angular/core';

declare var alertify:any;


@Injectable({
  providedIn: 'root'
})
export class AlertifyService {

constructor() { }


ErrorMessage(Msg:string){
  alertify.error(Msg);
}

SuccessMessage(Msg:string){
  alertify.success(Msg);
}

}
